import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '../../../redux/store';

import { fetchSingleSuperAdminUser } from '@actions/superAdminUsers/fetchSingleSuperAdminUser';
import { getSuperAdminUser, getSuperAdminUserPostSuccess } from '@selectors/superAdminUsers';

import SuperAdminUser from './SuperAdminUser';

import UpdateSuperAdminPasswordModal from './UpdateSuperAdminPasswordModal';
import DeleteSuperAdminModal from './DeleteSuperAdminModal';
import UpdateSuperAdminModal from './UpdateSuperAdminModal';
import usePrevious from 'lib/src/hooks/usePrevious';
import RevokeSuperAdminMfaModal from './RevokeSuperAdminMfaModal';
import useRoles from 'lib/src/hooks/useRoles';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';

const AdminUserContainer: React.FC = () => {
    const dispatch = useDispatch();
    const { id, action } = useParams<{ id: string; action?: string }>();

    const postSuccess = useSelector(getSuperAdminUserPostSuccess);
    const prevSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (postSuccess && !prevSuccess) dispatch(fetchSingleSuperAdminUser(+id));
    }, [postSuccess, prevSuccess, id, dispatch]);

    useEffect(() => {
        dispatch(fetchSingleSuperAdminUser(+id));
    }, [id, dispatch]);

    const user = useAppSelector(state => getSuperAdminUser(state, parseInt(id)));

    const userAccessRoles = useRoles();
    const hasSuperAdminAccess = userAccessRoles.includes(userRoles.superAdmin);

    return (
        <>
            <SuperAdminUser user={user} hasSuperAdminAccess={hasSuperAdminAccess} />
            {action === 'delete' && <DeleteSuperAdminModal user={user} />}
            {!!user && action === 'edit-password' && <UpdateSuperAdminPasswordModal user={user} />}
            {!!user && action === 'edit' && <UpdateSuperAdminModal user={user} />}
            {hasSuperAdminAccess && !!user && user.hasMfa && action === 'revoke-mfa' && (
                <RevokeSuperAdminMfaModal user={user} />
            )}
        </>
    );
};

export default AdminUserContainer;
